import { palette } from '../../../settings/themes/colors';

const styles = () => ({
  loader: {
    padding: 24,
    textAlign: 'center'
  },
  emptyState: {
    padding: '24px 0',
    textAlign: 'center',
    color: palette.dimGray
  },
  table: {
    width: '100%',
    tableLayout: 'fixed'
  },
  tableRowContainer: {
    borderBottom: `1px solid ${palette.darkGray20}`
  },
  tableHeader: {
    fontSize: '14px',
    lineHeight: '19px',
    whiteSpace: 'nowrap',
    '& *': {
      fontWeight: 500
    }
  },
  fileColumn: {
    width: '45%'
  },
  filename: {
    whiteSpace: 'normal',
    wordBreak: 'break-word'
  },
  compactColumn: {
    whiteSpace: 'nowrap'
  },
  statusChip: {
    color: palette.white,
    fontWeight: 'bold',
    backgroundColor: palette.dimGray
  },
  statusChip_completed: {
    backgroundColor: palette.emerald
  },
  statusChip_processing: {
    backgroundColor: palette.captuDataYellow
  },
  statusChip_failed: {
    backgroundColor: palette.candy
  },
  statusChip_expired: {
    backgroundColor: palette.dimGray
  }
});

export default styles;
